import { put } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

const requestSchema = z.object({
  deviceId: z.number(),
  name: z.string(),
});

const responseSchema = z.string();

interface UseUpdateHostedTimeFacilityParams {
  deviceId: number;
  facilityId: string;
  name: string;
}

const HOSTED_TIME_FACILITY_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/hosted-time/facility`;

const UPDATE_HOSTED_TIME_FAILURE = "Settings Redesign: Update HostedTime Facility Failure";

export function useUpdateHostedTimeFacility() {
  return useMutation({
    mutationFn: async (parameters: UseUpdateHostedTimeFacilityParams) => {
      const response = await put({
        url: `${HOSTED_TIME_FACILITY_URL}/${parameters.facilityId}`,
        data: { name: parameters.name, deviceId: parameters.deviceId },
        bodySchema: requestSchema,
        responseSchema,
      });
      return response.data;
    },
    meta: { logErrorMessage: UPDATE_HOSTED_TIME_FAILURE },
  });
}
